import ENLogin from "src/pages/Login/translations";
import ENForgotPassword from "src/pages/ForgotPassword/translations";
import ENBusinessGroup from "src/pages/Config/BusinessGroup/translations";
import ENRiskClassification from "src/pages/Risks/Classification/translations";
import ENMeasureUnits from "src/pages/Config/MeasureUnits/translations";
import ENClassification from "src/pages/Config/Classification/translations";
import ENSector from "src/pages/Config/Sectors/translations";
import ENProcess from "src/pages/Config/Process/translations";
import ENTags from "src/pages/Config/Tags/translations";
import ENPeriodType from "src/pages/Config/PeriodTypes/translations";
import ENMetrics from "src/pages/Config/Metrics/translations";
import ENMaps from "src/pages/StrategicPlanning/Maps/translations";
import ENIniciatives from "src/components/ModalIniciatives/Iniciatives/translations";
import ENPerspective from "src/pages/StrategicPlanning/Maps/Components/Perspective/translations";
import ENMapsObjective from "src/pages/StrategicPlanning/Maps/Components/Objectives/translations";
import ENOrgChart from "src/components/OrgChart/translations";
import ENCanvasModels from "src/pages/Config/CanvasModels/translations";
import ENIndicatorFields from "src/pages/Indicators/Fields/translations";
import ENRoom from "src/pages/Meetings/Rooms/translations";
import ENIndicatorModal from "src/components/ModalIndicator/translations";
import ENIndicators from "src/pages/Indicators/Indicators/translations";
import ENMeetingType from "src/pages/Meetings/MeetingType/translations";
import ENStandards from "src/pages/Audits/Standards/translations";
import ENActionsPanel from "src/pages/Actions/Panel/translations";
import ENCompetitors from "src/pages/Analysis/Config/Competitors/translations";
import ENDimensions from "src/pages/Analysis/Config/Dimensions/translations";
import ENBCGItems from "src/pages/Analysis/Config/BCGItems/translations";
import ENOriginOccurrences from "src/pages/Occurrences/Config/Origin/translations";
import ENPanelOccurrences from "src/pages/Occurrences/Panel/translations";
import ENStepsOccurrences from "src/pages/Occurrences/Config/Steps/translations";
import ENRequirementsOccurrences from "src/pages/Occurrences/Config/Requirements/translations";
import ENTerms from "src/pages/Config/TermsUse/translations";
import ENCategoriesOccurences from "src/pages/Occurrences/Config/Categories/translations";
import ENOKR from "src/pages/StrategicPlanning/Okr/translations";
import ENRisks from "src/pages/Risks/Panel/translations";
import ENRiskMatrix from "src/pages/Risks/Matrix/translations";
import ENIndicatorHierarchy from "src/pages/Indicators/Hierarchy/translations";
import ENIndicatorsPanel from "src/pages/Indicators/Panel/translations";
import ENPresentationGroup from "src/pages/Indicators/PresentationGroup/translations";
import ENGoalManagement from "src/pages/Indicators/Panel/components/ModalGoalManagement/translate";
import ENIndicatorsPresentationPanel from "src/pages/Indicators/PresentationPanel/translation";
import ENPrioritizationMatrix from "src/pages/Actions/PrioritizationMatrix/translations";
import ENFinalncialManagement from "src/pages/FinancialManagement/Panel/translations";
import ENConsultValuesFinancialManagement from "src/pages/FinancialManagement/ConsultValues/translations";
import ENCanvas from "src/pages/BusinessDiagnostics/Canvas/translations";
import ENUsers from "src/pages/Config/Users/translations";
import ENContractItems from "src/pages/Config/ContractItems/translations";
import ENCommercialPlans from "src/pages/Config/CommercialPlans/translations";
import ENMonitorContracts from "src/pages/Config/MonitorContracts/translations";
import ENUserGroup from "src/pages/Config/UserGroup/translations";
import ENMarketShare from "src/pages/Analysis/MarketShare/translations";
import ENStrategies from "src/pages/StrategicPlanning/Strategies/translations";
import ENExternalAccessKeys from "src/pages/Config/ExternalAccessKeys/translations";
import ENProjectsPanel from "src/pages/Projects/Panel/translation";
import ENProject from "src/pages/Projects/Project/translation";
import ENProgram from "src/pages/Projects/Program/translation";
import ENProjectPremisses from "src/pages/Projects/Project/Components/Premisses/translation";
import ENProjectRestrictions from "src/pages/Projects/Project/Components/Restrictions/translation";
import ENProjectPhases from "src/pages/Projects/Project/Components/Phases/translation";
import ENProjectSprint from "src/pages/Projects/Sprint/translation";
import ENKanban from "src/pages/Actions/Kanban/translations";
import ENDashboardComponentsTranslations from "src/components/DashboardComponents/translations";
import ENImportValues from "src/pages/Indicators/Import/translations";
import ENImportLogs from "src/pages/Indicators/Logs/translations";
import ENBusinessDiagnosticsModels from "src/pages/BusinessDiagnostics/Models/translations";
import ENBusinessDiagnostics from "src/pages/BusinessDiagnostics/Diagnostics/translations";
import ENSWOT from "src/pages/Analysis/SWOT/translation";
import ENSWOTStrategies from "src/pages/Analysis/Config/SWOTStrategy/translations";
import ENIntegrationTypes from "src/pages/Config/IntegrationTypes/translations";
import ENDataOrigin from "src/pages/Config/DataOrigin/translations";
import ENModalFormulaAssistant from "src/components/ModalFormulaAssistant/translations";
import ENReportsCrud from "src/pages/Reports/Config/translation";
import ENProfile from "src/pages/Profile/translations";
import ENPermissions from "src/pages/Config/Permissions/translations";
import ENAuditsPanel from "src/pages/Audits/Panel/translations";
import ENBusiness from "src/pages/Config/Business/translations";
import ENMapHierarchy from "src/pages/StrategicPlanning/MapHierarchy/translations";
import ENReportsView from "src/pages/Reports/View/translation";
import ENReportsPanel from "src/pages/Reports/Panel/translation";
import ENSystemConnections from "src/pages/Config/SystemConnections/translations";
import ENParametersConfig from "src/pages/Config/Parameters/config/translations";
import ENParametersHierarchy from "src/pages/Config/Parameters/Hierarchy/translations";
import ENIntegrations from "src/pages/Config/Integrations/translations";
import ENMyBusinessGroup from "src/pages/MyBusinessGroup/translations";
import ENModalIndicatorsPermissions from "src/components/ModalIndicatorsPermissions/translations";
import ENAnalysisPanel from "src/pages/Analysis/Panel/translations";
import ENNotifications from "src/pages/Config/Notifications/translations";
import ENCalendar from "src/pages/Calendar/translations";
import ENMeetingsPanel from "src/pages/Meetings/Panel/translations";
import ENMatrizBcg from "src/pages/Analysis/MatrizBCG/translations";
import ENNotificationsDefaultPhrases from "src/components/Shared/Notifications/translations";
import ENAccessIP from "src/pages/Config/AccessIP/translations";
import ENSuggestions from "src/pages/Config/Suggestions/translations";
import ENBudgetLogs from "src/pages/FinancialManagement/BudgetLogs/translations";
import ENDomain from "src/pages/Config/Domains/translations";

import ENSelectUsers from "src/components/SelectUsers/translations";
import ENFishBoneChart from "src/components/FCA/FishBoneChart/translations";

import ENCoins from "src/pages/Config/Coins/translations";
import ENFinancialManagementAccounting from "src/pages/FinancialManagementAccounting/translations";
import ENPhrases from "./phrases";
import ENWords from "./words";

export default { 
	...ENAuditsPanel,
	...ENCanvasModels,
	...ENLogin,
	...ENForgotPassword,
	...ENBusinessGroup,
	...ENBusiness,
	...ENRiskClassification,
	...ENMeasureUnits,
	...ENClassification,
	...ENSector,
	...ENProcess,
	...ENPeriodType,
	...ENTags,
	...ENMetrics,
	...ENIndicatorFields,
	...ENIndicatorsPanel,
	...ENModalIndicatorsPermissions,
	...ENMaps,
	...ENMapHierarchy,
	...ENMapsObjective,
	...ENOrgChart,
	...ENRoom,
	...ENMeetingType,
	...ENStandards,
	...ENActionsPanel,
	...ENKanban,
	...ENCompetitors,
	...ENDimensions,
	...ENBCGItems,
	...ENBCGItems,
	...ENOriginOccurrences,
	...ENPanelOccurrences,
	...ENStepsOccurrences,
	...ENRequirementsOccurrences,
	...ENTerms,
	...ENOKR,
	...ENCategoriesOccurences,
	...ENRisks,
	...ENRiskMatrix,
	...ENIndicatorModal,
	...ENIndicators,
	...ENProjectsPanel,
	...ENProject,
	...ENProjectPremisses,
	...ENProjectRestrictions,
	...ENProjectPhases,
	...ENProjectSprint,
	...ENProgram,
	...ENIniciatives,
	...ENPerspective,
	...ENIndicatorHierarchy,
	...ENPresentationGroup,
	...ENGoalManagement,
	...ENIndicatorsPresentationPanel,
	...ENPrioritizationMatrix,
	...ENImportValues,
	...ENImportLogs,
	...ENBusinessDiagnosticsModels,
	...ENBusinessDiagnostics,
	...ENSWOT,
	...ENDashboardComponentsTranslations,
	...ENUsers,
	...ENSelectUsers,
	...ENContractItems,
	...ENUserGroup,
	...ENSystemConnections,
	...ENIntegrations,
	...ENCommercialPlans,
	...ENMonitorContracts,
	...ENMarketShare,
	...ENMatrizBcg,
	...ENStrategies,
	...ENExternalAccessKeys,
	...ENNotifications,
	...ENFinalncialManagement,
	...ENConsultValuesFinancialManagement,
	...ENCanvas,
	...ENIntegrationTypes,
	...ENDataOrigin,
	...ENModalFormulaAssistant,
	...ENAnalysisPanel,
	...ENSWOTStrategies,
	...ENReportsCrud,
	...ENReportsView,
	...ENReportsPanel,
	...ENParametersConfig,
	...ENParametersHierarchy,
	...ENMeetingsPanel,
	...ENMyBusinessGroup,
	...ENProfile,
	...ENPermissions,
	...ENAccessIP,
	...ENCalendar,
	...ENSuggestions,
	...ENFishBoneChart,
	...ENBudgetLogs,
	...ENCoins,
	...ENDomain,
	...ENFinancialManagementAccounting,

	...ENNotificationsDefaultPhrases,

	...ENWords,
	...ENPhrases
};
